import {Component} from "@angular/core";
import {first} from "rxjs/operators";

import {ViewManagerService} from "../../services/view-manager.service";
import {SessionManagerService} from "../../services/session-manager.service";
import {Level, Message} from "../../model/message.component";

@Component({
  selector: "app-signout",
  templateUrl: "./signout.component.html",
  styleUrls: ["./signout.component.css"]
})
export class SignoutComponent {

  constructor(
    private sessionManager: SessionManagerService,
    private viewManager: ViewManagerService
  ) {
    this.viewManager.cleanMessages();

    this.sessionManager.logout()
      .pipe(first())
      .subscribe({
        next: () => {
          let message = "logout successful"
          this.viewManager.displayMessage(new Message(message, new Level("warning")))
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

}
